import { csrfFetch } from 'javascripts/csrf_token';
import React from 'react';
import UserSelector from '../UserSelector/UserSelector';
import { type UserSelectorProps } from '../UserSelector/UserSelector';

type StakeholderProps = Omit<UserSelectorProps, 'onSelect' | 'onClear'> & {
  toggleUrl?: string;
  clearUrl?: string;
};

const Stakeholders: React.FC<StakeholderProps> = ({
  toggleUrl,
  clearUrl,
  ...props
}) => {
  const selectCallback = (user_id: string, selected: boolean) => {
    return csrfFetch(toggleUrl, {
      method: 'PUT',
      body: JSON.stringify({
        toggle: selected ? '1' : '0',
        stakeholder: {
          user_id,
        },
      }),
    });
  };

  const clearCallback = () => {
    return csrfFetch(clearUrl, {
      method: 'DELETE',
    });
  };

  return (
    <UserSelector
      {...props}
      onSelect={selectCallback}
      onClear={clearCallback}
    />
  );
};

export default Stakeholders;
